import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class CompanyinfoController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "companyinfo";
    this.walkthroughState = WALKTHROUGH_STATES.COMPANY_INFO;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;

    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", ($event, params) => {
      this.saveDescription();
    });

    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
  }

  $onInit() {
    this.syncWithApi();
    this.blurElement();
  }

  blurElement() {
    this.$timeout(() => {
      $(document.activeElement).blur();
      this.focusEle();
    }, 100);
  }

  focusEle() {
    this.$timeout(() => {
      const el = document.getElementById("job-post-company-desc");
      el.focus();
    }, 100);
  }

  syncWithApi() {
    this.holdUser = true;
    this.setLoader();
    this.$events.getEventCompanyDescription().then((data) => {
      this.event.company_info = data.data.company.description;
      this.$timeout(() => {
        this.holdUser = false;
        this.unSetLoader();
        this.removeLoadingBar();
      }, 2000);
    });
  }

  removeLoadingBar() {
    this.$timeout(() => {
      if (this.$rootScope && this.$rootScope.progress) {
        this.$rootScope.progress.complete();
      }
    }, 800);
  }

  validate() {
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
  }

  saveDescription() {
    this.$events.saveEventCompanyDescription(this.event.company_info).then((data) => {
      this.$tracking.reportPostAJobSubmitStep("company info");
      console.log("Saved company info:", data);
    });
  }

  goNext() {
    if (this.holdUser === true) {
      return;
    }
    this.saveDescription();
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }
}

CompanyinfoController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default CompanyinfoController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/companyinfo/companyinfo.controller.js